import { WAKELOOP_DAEMON_TASK_RESULT_SCHEMA_VERSION, wakeLoopDaemonTaskResultEnvelopeWriteSchema, } from "@wakeloop/schemas";
export const buildTaskResultEnvelope = (payload) => {
    const parsed = wakeLoopDaemonTaskResultEnvelopeWriteSchema.safeParse({
        v: WAKELOOP_DAEMON_TASK_RESULT_SCHEMA_VERSION,
        code: "service.task_result",
        payload,
    });
    if (!parsed.success) {
        throw new Error("invalid daemon task result envelope");
    }
    return parsed.data;
};
